import {
    CTA,
    Container,
    ContainerGutter,
    ContainerPadding,
    Text,
    styled,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../rootReducer'

const LegalNotesDisclaimerTextContainer = styled.div`
    p {
        margin: 0;
    }
`

export interface LegalNotesLayerProps {
    onCloseClick: () => void
}

export default function LegalNotesLayer(
    props: LegalNotesLayerProps
): React.JSX.Element {
    const legalNotes = useSelector(
        (state: RootState) => state.general.legalNotesText
    )
    const {t} = useTranslation('app')

    return (
        <>
            <Container
                gutter={ContainerGutter.static300}
                padding={ContainerPadding.static350}
                wrap="always"
            >
                <Text>
                    <LegalNotesDisclaimerTextContainer
                        dangerouslySetInnerHTML={{
                            __html: legalNotes,
                        }}
                    />
                </Text>
                <CTA
                    onClick={() => {
                        props.onCloseClick()
                    }}
                    tag="button"
                    emphasis="secondary"
                    aria-label={t('cta.singlePromotion.legalNotesClose')}
                >
                    {t('cta.singlePromotion.legalNotesClose')}
                </CTA>
            </Container>
        </>
    )
}
